import { BankOutlined, BarChartOutlined, CalendarOutlined, DashboardOutlined, GoldOutlined } from "@ant-design/icons";
import { MenuConfigItem } from "../../../../models/sistema/menuConfigItem";

export const diretoria: MenuConfigItem[] = [
  {
    label: "PAINEL GERAL",
    key: "/painelGeral",
    path: "/painelGeral",
    icon: <DashboardOutlined />,
  },
  {
    label: "SORTEIO",
    key: "/sorteioPai",
    path: "/sorteioPai",
    icon: <CalendarOutlined />,
    children: [
      {
        label: "ANEXOS",
        key: "/anexos",
        path: "/anexos",
      },
    ],
  },
  {
    label: "FINANCEIRO TÁTICO",
    key: "/financeiroTatico",
    path: "/financeiroTatico",
    icon: <GoldOutlined />,
    children: [
      {
        label: "GRUPO DE CONTA BANCÁRIA",
        key: "/grupoContaBanco",
        path: "/grupoContaBanco",
      },
    ],
  },
  {
    label: "RESULTADOS",
    key: "/resultados",
    path: "/resultados",
    icon: <BarChartOutlined />,
    children: [
      {
        label: "ENTRE FASES",
        key: "/comparativoEmpresa",
        path: "/comparativoEmpresa",
      },
      {
        label: "ENTRE EMPRESAS",
        key: "/comparativoResultadoEmpresa",
        path: "/comparativoResultadoEmpresa",
      },
      {
        label: "COMPOSIÇÃO DE RESULTADO DA EMPRESA",
        key: "/composicao",
        path: "/composicao",
      },
    ],
  },
  {
    label: "IMPOSTO",
    key: "/imposto",
    path: "/imposto",
    icon: <BankOutlined />,
    children: [
      {
        label: "IMPOSTOS E TAXAS",
        key: "/impostosTaxas",
        path: "/impostosTaxas",
      },
      {
        label: "PERFIL DE TAXA/IMPOSTO",
        key: "/perfilTaxaImposto",
        path: "/perfilTaxaImposto",
      },
      {
        label: "TIPOS DE TAXAS/IMPOSTOS",
        key: "/tipoTaxaImposto",
        path: "/tipoTaxaImposto",
      },
    ],
  },
];
